const DIRECTIONS = [
    {
        dx: 1 / 3,
        dy: 0,
        dx1: 1 / 3,
        dy1: -1 / 3,
        xDiv: 1,
        yDiv: 2,
        cDiv: 4,
        xOffset: -5,
        yOffset: 0,
    }, // left up
    {
        dx: 1 / 2,
        dy: 0,
        dx1: 1 / 2,
        dy1: -0.7,
        xDiv: 1,
        yDiv: 2,
        cDiv: 4,
        xOffset: -8,
        yOffset: 0,
    }, // center up
    {
        dx: 2 / 3,
        dy: 0,
        dx1: 2 / 3,
        dy1: -0.5,
        xDiv: 1,
        yDiv: 2,
        cDiv: 5,
        xOffset: 5,
        yOffset: 0,
    }, // right up
    //
    {
        dx: 0,
        dy: 1 / 4,
        dx1: -0.25,
        dy1: 1 / 4,
        xDiv: 2,
        yDiv: 1,
        cDiv: 3,
        xOffset: 0,
        yOffset: -5,
    }, // upper left
    {
        dx: 0,
        dy: 1 / 2,
        dx1: -0.4,
        dy1: 1 / 2,
        xDiv: 2,
        yDiv: 1,
        cDiv: 3,
        xOffset: 0,
        yOffset: -6,
    }, // center left
    {
        dx: 0,
        dy: 3 / 4,
        dx1: -0.3,
        dy1: 3 / 4,
        xDiv: 2,
        yDiv: 1,
        cDiv: 3,
        xOffset: 0,
        yOffset: 5,
    }, // bottom left
    //
    {
        dx: 1,
        dy: 1 / 4,
        dx1: 1.25,
        dy1: 1 / 4,
        xDiv: 1.05,
        yDiv: 1,
        cDiv: 1.2,
        xOffset: 0,
        yOffset: -5,
    }, // upper right
    {
        dx: 1,
        dy: 1 / 2,
        dx1: 1.4,
        dy1: 1 / 2,
        xDiv: 1.1,
        yDiv: 1,
        cDiv: 1.1,
        xOffset: 0,
        yOffset: 7,
    }, // center right
    {
        dx: 1,
        dy: 0.75,
        dx1: 1.25,
        dy1: 0.75,
        xDiv: 1.15,
        yDiv: 1,
        cDiv: 1.15,
        xOffset: 0,
        yOffset: 8,
    }, // bottom right
    //
    {
        dx: 1 / 3,
        dy: 1,
        dx1: 1 / 3,
        dy1: 4 / 3,
        xDiv: 1,
        yDiv: 1,
        cDiv: 1.3,
        xOffset: -5,
        yOffset: 0,
    }, // left down
    {
        dx: 1 / 2,
        dy: 1,
        dx1: 1 / 2,
        dy1: 5 / 3,
        xDiv: 1,
        yDiv: 1.1,
        cDiv: 1.3,
        xOffset: -5,
        yOffset: 0,
    }, // center down
    {
        dx: 2 / 3,
        dy: 0.9,
        dx1: 2 / 3,
        dy1: 1.5,
        xDiv: 1,
        yDiv: 1.1,
        cDiv: 1.3,
        xOffset: -5,
        yOffset: 0,
    }, // right down
];

export const levelsPlacement: ("left" | "center" | "right")[][] = [
    ["center"],
    ["center"],
    ["right"],
    ["center", "left"],
    ["center", "right"],
];

const circlePath = (cx: number, cy: number, r: number) => {
    return (
        "M " +
        cx +
        " " +
        cy +
        " m -" +
        r +
        ", 0 a " +
        r +
        "," +
        r +
        " 0 1,1 " +
        r * 2 +
        ",0 a " +
        r +
        "," +
        r +
        " 0 1,1 -" +
        r * 2 +
        ",0"
    );
};

const pointFromDiv = (div: HTMLElement) => {
    return {
        x: div.offsetLeft + div.offsetWidth / 2,
        y: div.offsetTop + div.offsetHeight / 2,
    };
};

export const pathFromDivs = (first: HTMLElement, second: HTMLElement) => {
    const positionA = pointFromDiv(first);
    const positionB = pointFromDiv(second);

    if (first.classList.contains("center")) {
        return `M${positionA.x},${positionA.y} L${positionB.x},${positionA.y} L${positionB.x},${positionB.y}`;
    } else {
        return `M${positionA.x},${positionA.y} L${positionA.x},${positionB.y} L${positionB.x},${positionB.y}`;
    }
};
